import 'jquery-validation';

import type { InjectionKey, Ref } from 'vue';

export const PortalPin = Symbol('PortalPin') as InjectionKey<boolean>;

export const ValidatorInstance = Symbol('ValidatorInstance') as InjectionKey<Ref<JQueryValidation.Validator | undefined>>;
